export const ACTION_TYPES = {
  SET_SELECTED_OFFER: 'offer/SET_SELECTED_OFFER',
  OPEN_PAGE_MARKETING: 'offer/SET_PAGE_MARKETING',
  HIDE_PAGE_MARKETING: 'offer/HIDE_PAGE_MARKETING',
  SET_DOC_URL: 'offer/SET_DOC_URL',
  SET_OFFER_DOC_URL: 'offer/SET_OFFER_DOC_URL',
  SET_SIGN_CERTIFIED_DOC_URL: 'offer/SET_SIGN_CERTIFIED_DOC_URL',
  SET_ERROR: 'offer/SET_ERROR',
  INITIALIZE_INSUREDGOODS: 'insuredGood/INITIALIZE_INSUREDGOODS',
  UPDATE_INSUREDGOOD: 'insuredGood/UPDATE_INSUREDGOOD',
  UPDATE_INSUREDGOOD_AMOUNT: 'insuredGood/UPDATE_INSUREDGOOD_AMOUNT',
  UPDATE_INSUREDGOODS_PURCHASE_DATE: 'insuredGood/UPDATE_INSUREDGOODS_PURCHASE_DATE',

  FETCH_OFFER_DOCUMENTS: 'offer/FETCH_OFFER_DOCUMENTS',
  FETCH_OFFER_DOCUMENTS_SUCCESS: 'offer/FETCH_OFFER_DOCUMENTS_SUCCESS',
  FETCH_OFFER_DOCUMENTS_ERROR: 'offer/FETCH_OFFER_DOCUMENTS_ERROR',

  FETCH_SIGN_CERTIFIED_DOCUMENTS: 'offer/FETCH_SIGN_CERTIFIED_DOCUMENTS',
  FETCH_SIGN_CERTIFIED_DOCUMENTS_SUCCESS: 'offer/FETCH_SIGN_CERTIFIED_DOCUMENTS_SUCCESS',
  FETCH_SIGN_CERTIFIED_DOCUMENTS_ERROR: 'offer/FETCH_SIGN_CERTIFIED_DOCUMENTS_ERROR'
};
